import { render, staticRenderFns } from "./company-description.vue?vue&type=template&id=3b82048a&lang=html&"
import script from "./company-description.vue?vue&type=script&lang=js&"
export * from "./company-description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports